import { Table, Text } from "@fluidattacks/design";
import { Fragment, useMemo } from "react";

import { getColumns } from "./utils";

import type { ILineError } from "../types";
import { useTable } from "hooks/use-table";

interface IInvalidRootsTableProps {
  readonly data: ILineError[];
  readonly total: number;
}

const InvalidRootsTable = ({
  data,
  total,
}: IInvalidRootsTableProps): JSX.Element => {
  const columns = useMemo(getColumns, []);

  const dataWithIds = data.map(
    (item, index): ILineError => ({
      ...item,
      id: `invalid-root-${index}`,
    }),
  );

  const { table } = useTable<ILineError, object, string>({
    columns,
    data: dataWithIds,
    id: "invalid-roots",
    options: {
      filtersMode: "client-side",
      paginationMode: "client-side",
    },
    total,
  });

  return (
    <Fragment>
      <Text size={"md"}>
        {`In ${total} lines processed, we have detected `}
        <b>{`${data.length} errors:`}</b>
      </Text>
      <Table table={table}>
        <Table.Options />
        <Table.Content />
        <Table.Footer />
      </Table>
      <Text fontWeight={"bold"} size={"md"}>
        {"Please correct these repositories and upload again"}
      </Text>
    </Fragment>
  );
};

export { InvalidRootsTable };
